import { Button } from "../components/ui/button";
import { Download } from "lucide-react";
import { downloadCSV } from "../lib/download";
import { toast } from "sonner";

export default function ExportButton({ path, filename, label = "Export CSV", testId }) {
  const onClick = async () => {
    try {
      await downloadCSV(path, filename);
      toast.success("Downloaded");
    } catch (e) {
      toast.error("Export failed");
    }
  };
  return (
    <Button onClick={onClick} variant="outline" className="rounded-sm border-slate-300" data-testid={testId}>
      <Download className="h-4 w-4 mr-2"/>{label}
    </Button>
  );
}
